import React from 'react';  
import './Admin.css';
import MastersForm from '../../components/Admin/MastersForm';
 
const Admin: React.FC = () => {
 
   
 

  return (
    <div className="Lectors-container">
      <div className="ctitle-container-courses">
        <h1 className="courses-title">Admin</h1>
        <h1 className="courses-subtext">Some text here about the masters</h1>
      </div>
      <h1 className="courses-title">Masters: </h1>
      <MastersForm />
      <h1 className="courses-title">Programs: </h1>
      <h1 className="courses-title">Events: </h1>
    </div>
  );
};

export default Admin;
